module.exports = __webpack_public_path__ + "img/logo.ec6b69f6.png";